function speedMsFromPointsByLatestTimestamp(points: any[]): number | undefined {
  if (!points?.length) return undefined;
  let best: any = null;
  let bestTs = -Infinity;
  let anyTs = false;
  points.forEach((pt) => {
    const ts = typeof pt?.timestampSecEpoch === 'number' ? pt.timestampSecEpoch : NaN;
    if (!Number.isNaN(ts)) {
      anyTs = true;
      if (ts >= bestTs) {
        bestTs = ts;
        best = pt;
      }
    }
  });
  if (anyTs && best != null && typeof best.speedMs === 'number') return best.speedMs;
  const last = points[points.length - 1];
  return typeof last?.speedMs === 'number' ? last.speedMs : undefined;
}

function speedMsFromCoordinatesMatchingPin(coordinates: any[]): number | undefined {
  if (!coordinates?.length) return undefined;
  const firstShown = coordinates.find((c: any) => c?.latitude && c?.longitude) ?? coordinates[0];
  if (typeof firstShown?.speedMs === 'number') return firstShown.speedMs;
  const last = coordinates[coordinates.length - 1];
  return typeof last?.speedMs === 'number' ? last.speedMs : undefined;
}

export function lastPointSpeedMs(item: any): number | undefined {
  if (!item || typeof item !== 'object') return undefined;
  if (Array.isArray(item.points) && item.points.length) {
    return speedMsFromPointsByLatestTimestamp(item.points);
  }
  if (Array.isArray(item.coordinates) && item.coordinates.length) {
    return speedMsFromCoordinatesMatchingPin(item.coordinates);
  }
  if (typeof item.speedMs === 'number') return item.speedMs;
  return undefined;
}

function itemSpeedMergeTimestamp(item: any): number {
  if (Array.isArray(item?.points) && item.points.length) {
    let maxTs = -Infinity;
    item.points.forEach((pt: any) => {
      const t = typeof pt?.timestampSecEpoch === 'number' ? pt.timestampSecEpoch : NaN;
      if (!Number.isNaN(t)) maxTs = Math.max(maxTs, t);
    });
    return maxTs;
  }
  const t = typeof item?.timestampSecEpoch === 'number' ? item.timestampSecEpoch : NaN;
  return Number.isNaN(t) ? NaN : t;
}

export function buildSpeedMsByEntityId(data: any[] | null | undefined): Record<string, number> {
  const out: Record<string, number> = {};
  const bestTs: Record<string, number> = {};
  if (!Array.isArray(data)) return out;
  data.forEach((item) => {
    const key = item?.id ?? item?.vehicleId ?? item?.deviceId ?? item?.driverId;
    if (typeof key !== 'string') return;
    const s = lastPointSpeedMs(item);
    if (typeof s !== 'number') return;
    const ts = itemSpeedMergeTimestamp(item);
    if (Number.isNaN(ts)) {
      out[key] = s;
      return;
    }
    if (ts >= (bestTs[key] ?? -Infinity)) {
      bestTs[key] = ts;
      out[key] = s;
    }
  });
  return out;
}

export function latestSpeedMsFromTripData(data: any[]): number | undefined {
  if (!Array.isArray(data) || !data.length) return undefined;
  let best: any = null;
  let bestTs = -Infinity;
  let anyTs = false;
  data.forEach((p) => {
    const ts = typeof p?.timestampSecEpoch === 'number' ? p.timestampSecEpoch : NaN;
    if (!Number.isNaN(ts)) {
      anyTs = true;
      if (ts >= bestTs) {
        bestTs = ts;
        best = p;
      }
    }
  });
  if (anyTs && best != null && typeof best.speedMs === 'number') return best.speedMs;
  const last = data[data.length - 1];
  return typeof last?.speedMs === 'number' ? last.speedMs : undefined;
}
